import Vue from 'vue'
import { camelCase, upperFirst } from 'lodash'
import Meta from 'vue-meta'

import VueMoment from 'vue-moment'
import moment from 'moment-timezone'
import VueScrollTo from 'vue-scrollto'
import VeeValidate, { Validator } from 'vee-validate'
import VueHead from 'vue-head'
import sanitizeHTML from 'sanitize-html'
// eslint-disable-next-line
import i18n from './locales/i18n'
// eslint-disable-next-line
import DeviceDetect from './plugins/DeviceDetect'
// eslint-disable-next-line
import App from './App'
// eslint-disable-next-line
import router from './routes'
// eslint-disable-next-line
import store from './store'
// eslint-disable-next-line
import AuthenticatedLayout from './layouts/AuthenticatedLayout'
// eslint-disable-next-line
import Checkbox from './components/Checkbox'
// eslint-disable-next-line
import jaDict from './plugins/vee-validate/ja-dict'
// eslint-disable-next-line
import * as filters from './utils/filters'
// eslint-disable-next-line
import './registerServiceWorker'
import 'bootstrap'

Vue.prototype.$sanitize = sanitizeHTML

/**
 * Main App controller.
 */
class Main {
  /**
   * Base config env for Vue app.
   */
  static baseConfig = () => {
    Vue.config.productionTip = false
    Vue.use(VueHead)
    Vue.use(Meta)
    Vue.use(DeviceDetect)
    Vue.use(VueScrollTo)
    Vue.use(VueMoment, {
      moment
    })

    moment.tz.setDefault('Asia/Tokyo')
    moment.locale('ja')
    Vue.use(VeeValidate)
    Validator.localize('ja', jaDict)
    Vue.component('checkbox', Checkbox)

    Validator.extend('email_strict', {
      validate: (value) => {
        const regExp = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/i
        return regExp.test(value)
      }
    })
  }

  /**
   * Register global components.
   */
  static registerGlobalBaseComponent = () => {
    try {
      const requireComponent = require.context(
        // The relative path of the components folder
        './components',
        // Whether or not to look in subfolders
        false,
        // The regular expression used to match base component filenames
        /[A-Z]\w+\.(vue|js)$/
      )

      requireComponent.keys().forEach((fileName) => {
        // Get component config
        const componentConfig = requireComponent(fileName)

        // Get PascalCase name of component
        const componentName = upperFirst(
          camelCase(
            // Gets the file name regardless of folder depth
            fileName
              .split('/')
              .pop()
              .replace(/\.\w+$/, '')
          )
        )

        // Register component globally
        Vue.component(
          `Base${componentName}`,
          // Look for the component options on `.default`, which will
          // exist if the component was exported with `export default`,
          // otherwise fall back to module's root.
          componentConfig.default || componentConfig
        )
      })
    } catch (e) {
      throw new Error('Global components not found!')
    }
  }

  /**
   * Register global layout components.
   */
  static registerGlobalLayoutComponent = () => {
    Vue.component('AuthenticatedLayout', AuthenticatedLayout)
  }

  /**
   * Render SPA App container.
   *
   * @returns {(Vue | any)|*}
   */
  static renderApp = () => {
    return new Vue({
      router,
      store,
      i18n,
      render: createElement => createElement(App),
      renderError(h, err) {
        return h('pre', {
          style: {
            color: 'red'
          }
        }, err.stack)
      },
    }).$mount('#app')
  }

  static registerGlobalFilter = () => {
    Object.keys(filters).forEach((key) => {
      Vue.filter(key, filters[key])
    })
  }

  static run() {
    Main.baseConfig()
    Main.registerGlobalBaseComponent()
    Main.registerGlobalLayoutComponent()
    Main.registerGlobalFilter()
    Main.renderApp()
  }
}

Main.run()
